export enum CardCovered {
    LEFT = 'card-covered-left',
    RIGHT = 'card-covered-right',
}
